import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorMessage from 'components/share/ErrorMessage'

interface UnexpectedErrorBoundaryProps {
  children: React.ReactNode
}

const UnexpectedErrorBoundary = ({ children }: UnexpectedErrorBoundaryProps) => {
  const { t } = useTranslation()

  return (
    <ErrorBoundary FallbackComponent={() => <ErrorMessage>{t('unexpectedError')}</ErrorMessage>}>
      {children}
    </ErrorBoundary>
  )
}

export default UnexpectedErrorBoundary
